export default __webpack_public_path__ + "static/media/notUploaded.7c0382a1.svg";